import { render, staticRenderFns } from "./OrderActionBillMessage.vue?vue&type=template&id=2f06d04e&"
import script from "./OrderActionBillMessage.vue?vue&type=script&lang=ts&"
export * from "./OrderActionBillMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports